import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 40px 24px',
    height: '100%',
    flexWrap: 'wrap'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  formContainer: {
    margin: '0 40px',
    padding: '20px 40px',
  },
  buttonContainer: {
    display: 'flex',
    marginTop: '20px'
  },
  button: {
    maxWidth: 220,
  },
  primaryButton: {
    color: 'white',
    marginRight: '20px'
  },
  userHeaderWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '20px 20px',
  },
  mr4: {
    marginRight: '2rem',
  },
  mt4: {
    marginTop: '60px',
  },
  cardTitle: {
    marginBottom: '15px',
    fontSize: '20px',
    color: '#545456'
  },
  submitButton: {
    maxWidth: '220px',
    color: 'white',
    float: 'right'
  },
  cardData: {
    fontSize: '12px',
    color: '#939497',
  },
  cardValue: {
    fontSize: '14px',
    color: '#545455',
    wordBreak: 'break-word',
  },
  actionStyle: {
    display: 'flex',
    justifyContent: 'center'
  },
  circleIcon: {
    verticalAlign: 'middle',
    float: 'right'
  },
  nameInTable: {
    width: '33%',
    minWidth: '120px',
    maxWidth: '200px',
    wordBreak: 'break-word'
  },
  nameInAccountTable: {
    width: '50%',
    minWidth: '120px',
    maxWidth: '300px',
    wordBreak: 'break-word'
  }
}))

export { useStyles }